import React from 'react';
import './loading-spinner.css';

export const Loading: React.FC = () => (
	<div style={{ textAlign: 'center', marginTop: 20, height: '100vh', width: '100%' }}>
		<div className="loader">Loading...</div>
	</div>
);
